import { Controller } from '@hotwired/stimulus'
import { DirectUpload } from '@rails/activestorage'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['input', 'label', 'progress', 'progressBar']
  static values = {
    url: String,
    callbackUrl: String,
    maxFiles: { type: Number, default: 5 },
    maxFileSize: { type: Number, default: 5 }
  }

  async upload (event) {
    const files = event.target.files

    // Validation
    if (files.length > this.maxFilesValue) {
      window.alert(`Maximum of ${this.maxFilesValue} files are permitted.`)
      this.inputTarget.value = null
      return
    }

    const hasLargeFile = Array.from(files).some(file => file.size > this.maxFileSizeValue * 1024 * 1024)
    if (hasLargeFile) {
      window.alert(`Maximum file size is ${this.maxFileSizeValue}MB.`)
      this.inputTarget.value = null
      return
    }

    // Show progress
    this.progressTarget.classList.remove('hidden')
    this.progressBarTarget.style.width = '0%'

    try {
      // Upload files to Active Storage
      const blobs = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        const blob = await this.uploadFile(file)
        blobs.push(blob)

        // Update progress
        const progress = ((i + 1) / files.length) * 100
        this.progressBarTarget.style.width = `${progress}%`
      }

      // Send blob IDs to server to create assets
      await post(this.callbackUrlValue, {
        body: JSON.stringify({ blob_ids: blobs.map(b => b.signed_id) }),
        contentType: 'application/json',
        responseKind: 'turbo-stream'
      })

      // Reset
      this.inputTarget.value = null
      this.progressTarget.classList.add('hidden')
    } catch (error) {
      console.error('Upload error:', error)
      window.alert('Upload failed. Please try again.')
      this.progressTarget.classList.add('hidden')
      this.inputTarget.value = null
    }
  }

  uploadFile (file) {
    return new Promise((resolve, reject) => {
      const upload = new DirectUpload(file, this.urlValue)

      upload.create((error, blob) => {
        if (error) {
          reject(error)
        } else {
          resolve(blob)
        }
      })
    })
  }
}
